// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";

interface SubHeaderHomeProps {
  agencyName?: string;
  isSeo: boolean;
  showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
  showSearchForm = false // Default a true se non specificato
}) => {
  const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
  const { t } = useTranslation();

  if (loading) return <LoadingIndicator />;
  if (error) return <SlowLoadComponent />;

  if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

  return (
    <section className="banner bg-overlay-black-20">
            <p className="text-white"
              dangerouslySetInnerHTML={{ __html: t('homePage.heroTitle') as string }}
            />
            {showSearchForm && <PropertySearchField searchData={{}} />}
    </section>
  );
};

export default SubHeaderHome;